import { Alert, RadioChangeEvent } from 'antd';
import React, { useState } from 'react';
import { ReactComponent as WarningIcon } from '../../images/icon-warning.svg';
import { IngestionSourceList } from './source/IngestionSourceList';
import { SecretsList } from './secret/SecretsList';
import { SearchHeader } from '../search/SearchHeader';
import { IngestionTabType } from '../shared/admin/HeaderLinks';
import { useTranslation } from '../../i18n/useTranslation';
import { useRbac } from '../entity/shared/useRbac';
import { useUserContext } from '../context/useUserContext';
import { ComponentSpinner } from '../shared/ComponentSpinner';
import { UnauthorisedPage } from '../shared/UnauthorisedPage';

export const ManageIngestionPage = () => {
    const { t } = useTranslation();
    const { platformPrivileges } = useUserContext();
    const { resolveIngestionPrivileges, resolveSecretPrivileges } = useRbac();
    const privileges = resolveIngestionPrivileges();
    const secretPrivileges = resolveSecretPrivileges();

    const [selectedTab, setSelectedTab] = useState<IngestionTabType | null>(null);

    if (!platformPrivileges) return <ComponentSpinner />;

    const canShowSources = privileges.canView;
    const canShowSecrets = secretPrivileges.canView;

    if (!canShowSources && !canShowSecrets) return <UnauthorisedPage />;

    const activeTab = selectedTab ?? (canShowSources ? IngestionTabType.Sources : IngestionTabType.Secrets);

    const handleModeChange = (e: RadioChangeEvent) => {
        setSelectedTab(e.target.value);
    };

    return (
        <>
            <Alert
                showIcon
                type="warning"
                icon={<WarningIcon />}
                className="ma-2 f-alert-warning"
                message={t(
                    'System Update: This Ingestion page is being deprecated and will be replaced with a new experience.',
                )}
            />
            <SearchHeader
                ingestionTabType={activeTab}
                handleIngestionModeChange={handleModeChange}
                subtext={t('CREATE_SCHEDULE_RUN_INGESTION_PIPELINES_DESC')}
            >
                {activeTab === IngestionTabType.Sources ? (
                    <IngestionSourceList privileges={privileges} />
                ) : (
                    <SecretsList privileges={secretPrivileges} />
                )}
            </SearchHeader>
        </>
    );
};
